import React from "react";
import { Link } from "react-router-dom"; // if using react-router

const Footer = () => {
  return (
    <footer className="w-full border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 mt-10">
      <div className="max-w-7xl mx-auto px-4 py-6 flex flex-col sm:flex-row items-center justify-between text-sm text-gray-600 dark:text-gray-400">
        <p>&copy; {new Date().getFullYear()} Clairvoyant Inc. All rights reserved.</p>
        <div className="flex space-x-4 mt-4 sm:mt-0">
          <Link to="/privacy" className="hover:underline">Privacy Policy</Link>
          <Link to="/terms" className="hover:underline">Terms of Use</Link>
          <Link to="/blog" className="hover:underline">Blog</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
